import * as React from 'react';

import { cva, VariantProps } from 'class-variance-authority';
import { OmitStylesComponentProps } from '../../types';

const paginationVariants = cva('rocco-pagination', {
    variants: {
        variant: {
            default: 'mx-auto flex w-full justify-center',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export const Pagination = ({
    variant,
    ...props
}: OmitStylesComponentProps<'nav'> &
    VariantProps<typeof paginationVariants>) => (
    <nav
        role="navigation"
        aria-label="pagination"
        className={paginationVariants({ variant })}
        {...props}
    />
);

Pagination.displayName = 'Pagination';
